let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("69bE8")).then(() => parcelRequire('1BjZZ'));